import axiosInstance from 'api/axiosInstance';

export interface CustomerOption {
	Id: number;
	Name: string;
}

const searchCustomers = async (keyword: string): Promise<CustomerOption[]> => {
	try {
		const payload = { Id: 0, SearchKeyword: keyword, Page: 1, Take: 200 };
		const { data } = await axiosInstance.get(
			`/api/cantrackv3/ReadCustomers?payload=${JSON.stringify(payload)}`,
		);
		return data?.Data || [];
	} catch (error) {
		console.error('[searchCustomers] Failed:', error);
		throw error;
	}
};

export default searchCustomers;
